import { useState } from 'react';
import Icon from './osc-icon';
import type { IconProps } from './osc-icon';
import type { EYIconNames, ESIconNames, HPIconNames, OLIconNames } from './osc-brand-icon-map';
import type { IconNames } from './osc-icon-map';
import cx from 'classnames';

export type IconPropsWithIconList = IconProps & {
  icons:
    | typeof EYIconNames
    | typeof ESIconNames
    | typeof HPIconNames
    | typeof OLIconNames
    | typeof IconNames;
};
export const IconShowcase = ({
  size = 'md',
  variant,
  brandCode,
  icons,
}: Pick<IconPropsWithIconList, 'variant' | 'size' | 'icons' | 'brandCode'>) => {
  const [copiedIconName, setCopiedIconName] = useState('');
  return (
    <div className="grid auto-rows-[minmax(120px,auto)] grid-cols-6 gap-4">
      {icons.map((icon) => (
        <button
          className="flex flex-col items-center justify-between rounded border border-surface-legacy shadow-sm"
          key={icon}
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(icon);
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error('Could not copy icon name', error);
            } finally {
              setCopiedIconName(icon);
              setTimeout(() => {
                setCopiedIconName('');
              }, 1500);
            }
          }}
          type="button"
        >
          <Icon
            className="mt-8"
            {...({
              name: icon,
              size,
              ...(brandCode ? { brandCode } : variant ? { variant } : {}),
            } as IconProps)}
          />
          <span
            className={cx('w-full rounded-b p-1 transition-colors', {
              'bg-surface-success text-surface-success font-bold':
                copiedIconName && copiedIconName === icon,
              'surface-alternate': copiedIconName !== icon,
            })}
          >
            {copiedIconName && copiedIconName === icon ? 'Copied!' : icon}
          </span>
        </button>
      ))}
    </div>
  );
};
